import { log } from '@/utils'
import TC from './monitor.config'
// import Trackers from './trackers'
import Sensors from './trackers/SP/index'

const defaults = {}

class Tracker {
  constructor (options = {}) {}

  resolveEvent (...args) {
    let action = 'click'
    let category, label, value

    if (args.length === 1 && Array.isArray(args[0])) {
      ({ category, action, label, value } = args[0])
    } else if (args.length < 4) {
      [category, label, value] = args
    } else {
      [category, action, label, value] = args
    }

    return {
      category,
      action,
      label,
      value
    }
  }

  use (provider, config) {
    this._tracker = new Sensors()
  }

  setVar (type, params) {
    if (!this._tracker) return
    log.debug('[tracker] setVar: ', type, params)
    this._tracker.setVar(type, params)
  }

  trackEvents (...events) {
    try {
      if (typeof events[0] === 'string') {
        events = [events]
      }
      events.forEach((e) => {
        const evt = this.resolveEvent.apply(this, Array.isArray(e) ? e : [e])
        if (!this._tracker) return
        // log.debug('[tracker] trackEvents', evt)
        this._tracker.trackEvent(evt)
      })
    } catch (e) {
      console.log(e)
    }
  }
  // 对于api层提供埋点能力
  apiTracker (data = {}) {
    let { apiUrl = '' } = data
    const baseUrl = process.env.VUE_APP_BASE_API
    const baseUrlIdx = apiUrl.indexOf(process.env.VUE_APP_BASE_API)
    apiUrl = baseUrlIdx == -1 ? apiUrl : apiUrl.slice(baseUrl.length)
    data.apiUrl = apiUrl
    // console.log('apiTracker-data',apiUrl,data)
    if (!apiUrl || !TC.API_TRACK[apiUrl]) return
    const [events, keys, opts] = TC.API_TRACK[apiUrl]
    // console.log('TC.API_TRACK[url]',events, keys, opts)
    events.forEach((e, idx) => {
      TC.EVENT_LIST[e](keys[idx], Object.assign(opts[idx], data))
    })
  }
  dispatch (category, type, payload) {
    if (!this._tracker) return
    return this._tracker.dispatch(category, type, payload)
  }
}

function createInstance (options) {
  const inst = new Tracker(options)
  return inst
}

const tracker = createInstance(defaults)

console.log('tracker-index', tracker)
export default tracker
